/**
 * ## tableedit component
 *
 * @module src/components/tableedit
 */

"use strict";

const l = require("../../common").localization;

const selection = null;
const mode = null;
const transfer = null;

const genSelect = (pref, data) => {
  let output = "";
  for (let i = 0; i < data.location.preferenceTypes.length; ++i) {
    let s;
    if (pref === data.location.preferenceTypes[i].value) {
      s = "selected";
    } else {
      s = "";
    }
    output += `<option value="${data.location.preferenceTypes[i].value}" ${s}>\
${data.location.preferenceTypes[i].value}</option>`;
  }
  return output;
};

/**
 * tableedit display.
 */
const create = (options, data, callback) => {
  let tabledesc = l.translate("Delete Icon");
  let thisHTML = '<div id="tableedit_shell">';
  if (options.tabletype !== "icon") {
    tabledesc = l.translate("Delete Table");
    thisHTML += `${l.translate("Edit Table Number:")}<br><br>`;
    thisHTML += `<input type="text" class="textbox_single textbox_fullwidth theme_bg_charcoal" \
            id="tableNumberEdit" name="tableNumberValue" value="${data.table}">`;
  }
  thisHTML +=
    '<div id="tableRotate" class="tableedit_rotate"><i class="fas fa-redo" ' +
    'aria-hidden="true"></i></div>';
  if (options.tabletype !== "icon") {
    thisHTML += '<div class="tableedit_preference">';
    thisHTML += '<div class="tableedit_preference_label">';
    thisHTML += l.translate("Seat Pref");
    thisHTML += " 1: ";
    thisHTML += "</div>";
    thisHTML += '<select class="select-style" id="preference_1">';
    thisHTML += genSelect(data.tabledata.preference1, data);
    thisHTML += "</select>";
    thisHTML += "</div>";
    thisHTML += '<div class="tableedit_preference">';
    thisHTML += '<div class="tableedit_preference_label">';
    thisHTML += l.translate("Seat Pref");
    thisHTML += " 2: ";
    thisHTML += "</div>";
    thisHTML += '<select class="select-style" id="preference_2">';
    thisHTML += genSelect(data.tabledata.preference2, data);
    thisHTML += "</select>";
    thisHTML += "</div>";
  } else if (data.tabledata.seats === 8) {
    thisHTML += '<div class="tableedit_preference">';
    thisHTML += '<div class="tableedit_preference_label">';
    thisHTML += l.translate("Line Length");
    thisHTML += '<div class="clear"></div>';
    thisHTML += '<div class="btn_scale" id="tableeditScaleUp">';
    thisHTML += '<i class="fas fa-plus-square fa-4x"></i></div>';
    thisHTML += '<div class="btn_scale" id="tableeditScaleDown">';
    thisHTML += '<i class="fas fa-minus-square fa-4x"></i></div>';
    thisHTML += '<div class="clear"></div>';
    thisHTML += "</div>";
    thisHTML += "</div>";
  } else if (data.tabledata.seats === 12) {
    thisHTML += '<div class="tableedit_preference">';
    thisHTML += '<div class="tableedit_preference_label">';
    thisHTML += '<div class="form_spacer">';
    thisHTML += l.translate("Label Text");
    thisHTML += "</div>";
    thisHTML += '<div class="form_field_1">';
    thisHTML += '<input id="tabledit_custom_label" type="text"></div>';
    thisHTML += `<div id="tableSetLabel" class="btn9">${l.translate(
      "Set Label"
    )}</div></div>`;
    thisHTML += '<div class="clear"></div>';
    thisHTML += "</div>";
  } else if (data.tabledata.seats === 13) {
    thisHTML += '<div class="tableedit_preference">';
    thisHTML += '<div class="tableedit_preference_label">';
    thisHTML += l.translate("Width");
    thisHTML += '<div class="clear"></div>';
    thisHTML += '<div class="btn_scale" id="tableeditWidthUp">';
    thisHTML += '<i class="fas fa-plus-square fa-4x"></i></div>';
    thisHTML += '<div class="btn_scale" id="tableeditWidthDown">';
    thisHTML += '<i class="fas fa-minus-square fa-4x"></i></div>';
    thisHTML += '<div class="clear" style="height: 15px"></div>';
    thisHTML += "</div>";
    thisHTML += '<div class="tableedit_preference_label">';
    thisHTML += l.translate("Height");
    thisHTML += '<div class="clear"></div>';
    thisHTML += '<div class="btn_scale" id="tableeditHeightUp">';
    thisHTML += '<i class="fas fa-plus-square fa-4x"></i></div>';
    thisHTML += '<div class="btn_scale" id="tableeditHeightDown">';
    thisHTML += '<i class="fas fa-minus-square fa-4x"></i></div>';
    thisHTML += '<div class="clear"></div>';
    thisHTML += "</div>";
    thisHTML += "</div>";
  }
  thisHTML += '<div class="btn_center">';
  thisHTML += `<div id="tableDelete" class="btn9">${tabledesc}</div></div>`;
  thisHTML += "</div>";

  $(`#${options.target_id}`).html(thisHTML);

  $("#tableNumberEdit").off();
  $("#tableNumberEdit").on("blur", () => {
    let num = $("#tableNumberEdit").val();
    if (!isNaN(num)) {
      num = Number($("#tableNumberEdit").val());
    }
    const obj = {
      id: data.id,
      type: "numchange",
      table: num,
    };
    callback(null, obj);
  });

  $("#tableRotate").off();
  $("#tableRotate").fastClick((e) => {
    // e.stopPropagation();
    const obj = {
      id: data.id,
      type: "rotate",
      table: $("#tableNumberEdit").val(),
    };
    callback(null, obj);
  });

  $("#preference_1").change(() => {
    const obj = {
      id: data.id,
      type: "preference1",
      table: $("#tableNumberEdit").val(),
      preference: $("#preference_1").val(),
    };
    callback(null, obj);
  });

  $("#preference_2").change(() => {
    const obj = {
      id: data.id,
      type: "preference2",
      table: $("#tableNumberEdit").val(),
      preference: $("#preference_2").val(),
    };
    callback(null, obj);
  });

  $("#tableDelete").off();
  $("#tableDelete").fastClick((e) => {
    // e.stopPropagation();
    const obj = {
      id: data.id,
      type: "delete",
      table: $("#tableNumberEdit").val(),
    };
    destroy();
    callback(null, obj);
  });

  $("#tableedit_shell").off();
  $("#tableedit_shell").fastClick((e) => {
    e.preventDefault();
    e.stopPropagation();
  });

  $("#tableeditScaleUp").off();
  $("#tableeditScaleUp").fastClick((e) => {
    const obj = {
      id: data.id,
      type: "scaleUp",
      table: $("#tableNumberEdit").val(),
    };
    callback(null, obj);
  });

  $("#tableeditScaleDown").off();
  $("#tableeditScaleDown").fastClick((e) => {
    const obj = {
      id: data.id,
      type: "scaleDown",
      table: $("#tableNumberEdit").val(),
    };
    callback(null, obj);
  });

  $("#tableeditWidthUp").off();
  $("#tableeditWidthUp").fastClick((e) => {
    const obj = {
      id: data.id,
      type: "widthUp",
      table: $("#tableNumberEdit").val(),
    };
    callback(null, obj);
  });

  $("#tableeditWidthDown").off();
  $("#tableeditWidthDown").fastClick((e) => {
    const obj = {
      id: data.id,
      type: "widthDown",
      table: $("#tableNumberEdit").val(),
    };
    callback(null, obj);
  });

  $("#tableeditHeightUp").off();
  $("#tableeditHeightUp").fastClick((e) => {
    const obj = {
      id: data.id,
      type: "heightUp",
      table: $("#tableNumberEdit").val(),
    };
    callback(null, obj);
  });

  $("#tableeditHeightDown").off();
  $("#tableeditHeightDown").fastClick((e) => {
    const obj = {
      id: data.id,
      type: "heightDown",
      table: $("#tableNumberEdit").val(),
    };
    callback(null, obj);
  });

  $("#tabledit_custom_label").val(data.tabledata.label);

  $("#tableSetLabel").off();
  $("#tableSetLabel").fastClick((e) => {
    const obj = {
      id: data.id,
      type: "label",
      table: $("#tableNumberEdit").val(),
      label: $("#tabledit_custom_label").val(),
    };
    callback(null, obj);
  });
};

const destroy = () => {
  $("#component_catch").css("display", "none");
};

module.exports = {
  create,
  destroy,
};



/** WEBPACK FOOTER **
 ** ./src/components/tableedit/index.js
 **/